<template lang="pug">
  .div
    .columns
      h1.is-size-4
          strong  Nuevo Porteador
    .columns
      .column.is-4
        .field
          label.label Nombre
            .control.has-icons-left.has-icons-right
              input.input.is-black(
                type='text', 
                placeholder='Nombre..',
                v-model="nombre",
                :disabled="isDisabled"
              )
      .column.is-4
        .field
          label.label Clave
            .control.has-icons-left.has-icons-right
              input.input.is-black(
                type='text', 
                placeholder='Clave..',
                v-model="clave",
                :disabled="isDisabled"
              )
      .column.is-4
        .field
          label.label R.F.C.
            .control.has-icons-left.has-icons-right
              input.input.is-black(
                type='text', 
                placeholder='RFC..',
                v-model="rfc",
                :disabled="isDisabled"
              
              )
    .columns
      .column.is-2
        a.button.is-block(@click="cancelAdd")
          | Cancelar 
      .column.is-2
        a.button.is-black.is-block(@click="checkForm")
          | Guardar 
    .columns(v-show="datosFaltantes.length > 0")
      .notification
          .field.is-grouped.is-grouped-multiline
            .control(v-for="datosF in datosFaltantes")
              .tags
                span.tag.is-danger.is-light {{ datosF }}
</template>

<script>
  import sca_irgeServices from '@/services/sca/irge.js' 

export default {
  name: 'FormPorteadores',
  data() {
      return {
        nombre: null,
        clave: null,
        rfc: null,
        datosFaltantes: [],
        isDisabled: false
      }
    },
    methods: {
      checkForm() {
        if (this.nombre && this.rfc) {
          this.guardar()
        } else {
          this.datosFaltantes = []
          if (!this.nombre) {
            this.datosFaltantes.push('El nombre es requerido.')
          }
          if (!this.rfc) {
            this.datosFaltantes.push('El RFC es requerido.')
          }

        }
      },
      guardar() {
        sca_irgeServices.addPorteador(this.nombre, this.clave, this.rfc)
          .then( resp => {
            console.log(resp)
            if (resp.success) {
              let toast = this.$toasted.show(`El Porteador ha sido Guardado.`, { 
                theme: "toasted-primary", 
                position: "bottom-right", 
                duration : 3000,
                iconPack: 'fontawesome',
                icon: 'ban',
                action : {
                  text : 'Ok',
                  onClick : (e, toastObject) => {
                    toastObject.goAway(0)
                  }
                },
              })
              this.nombre = null
              this.clave = null
              this.rfc = null
              this.$emit('closeForm','saved')
            } else {
              let toast = this.$toasted.show(`Error: ${resp.respuesta}`, { 
                theme: "toasted-primary", 
                position: "bottom-right", 
                duration : 3000,
                iconPack: 'fontawesome',
                icon: 'ban',
                action : {
                  text : 'Ok',
                  onClick : (e, toastObject) => {
                    toastObject.goAway(0)
                  }
                },
              })
            }
          })
          .catch(e => console.log(e))
      },
      cancelAdd () {
        this.datosFaltantes = []
        this.nombre = null
        this.clave = null
        this.rfc = null
        console.log('Cancelar')
        this.$emit('closeForm','close')
      }
    },
  }
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/irge/FormPorteadores.vue